// GIF TOUR family (/tour/gif, /tour/pg, /tour/hc, whitelabel /tour) —
// vanilla replacement for the sprockets tour-core stack (jquery + underscore
// + backbone + sk-core + jquery.unveil + video-js). Three behaviors live
// here; everything else the old bundles did was dead code:
//  1. lazy tour pics  — was jquery.unveil(600) over img.tour-pics-delayed
//  2. special offer   — was a Backbone popup + video-js backdrop; the markup
//                       is now server-rendered (gif_tour/_special_offer) and
//                       the aspect-fill resize maps are CSS object-fit
//  3. whitelabel gateway — age-agreement overlay dismissal

// 1. Swap data-src into src as cards approach the viewport (600px early,
//    same threshold unveil used). The data-src URL is the sk_gif_tour
//    view-tracking URL, so impressions keep counting server-side.
function setupLazyTourPics() {
  const images = document.querySelectorAll('img.tour-pics-delayed[data-src]');
  if (!images.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const img = entry.target;
      observer.unobserve(img);
      img.src = img.dataset.src;
    });
  }, { rootMargin: '600px 0px' });

  images.forEach((img) => observer.observe(img));
}

// 2. Special offer interstitial: reveal the server-rendered modal, start the
//    backdrop video on non-mobile viewports (it stays src-less otherwise so
//    phones never download it), and tear everything down on "No thank you".
function setupSpecialOffer() {
  const modal = document.getElementById('sk-so-modal');
  if (!modal) return;

  const backdrop = document.querySelector('.sk-so-backdrop');
  const video = backdrop && backdrop.querySelector('video[data-src]');

  if (video && window.matchMedia('(min-width: 600px)').matches) {
    video.src = video.dataset.src;
    video.play();
  }

  document.body.classList.add('sk-so-visible');

  modal.querySelectorAll('.sk-so-modal-close').forEach((close) => {
    close.addEventListener('click', (event) => {
      event.preventDefault();
      document.body.classList.remove('sk-so-visible');
      if (video) video.pause();
      modal.remove();
      if (backdrop) backdrop.remove();
    });
  });
}

// 3. Whitelabel gateway: any .enter-tour control hides the overlay.
function setupWhitelabelGateway() {
  const gateway = document.getElementById('gateway-modal');
  if (!gateway) return;

  document.querySelectorAll('.enter-tour').forEach((enter) => {
    enter.addEventListener('click', (event) => {
      event.preventDefault();
      gateway.style.display = 'none';
      document.body.classList.remove('modal-open');
    });
  });
}

function init() {
  setupLazyTourPics();
  setupSpecialOffer();
  setupWhitelabelGateway();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
